import React from "react";
import { Link } from "react-router-dom";

export default function MerchantMobileBottomNav({ activeKey, items }) {
  return (
    <nav className="merchant-mobile-bottom-nav">
      {items.map(function renderNavItem(item) {
        const Icon = item.icon;

        return (
          <Link
            key={item.key}
            className={
              "merchant-mobile-bottom-nav-item" +
              (activeKey === item.key ? " active" : "")
            }
            to={item.path}
          >
            <span className="merchant-mobile-bottom-nav-icon">
              <Icon />
            </span>
            <span className="merchant-mobile-bottom-nav-label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
